import type { ComponentSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from './_fields'

/** Picture slides whose text is part of the image, each with an optional link. */
export const schema: ComponentSchema = {
  type: 'banner-carousel',
  label: 'Banner carousel',
  description: 'Full-width picture slides (offers, campaigns) with arrows, dots and autoplay.',
  supportedPages: ['home', 'shop', 'category', 'categories'],
  variants: [{ id: 'v1', label: 'Picture slides' }],
  commonFields: [
    { key: 'title', label: 'Name for screen readers', type: 'string', default: 'Offers' },
    {
      key: 'slides',
      label: 'Slides',
      type: 'array',
      itemSchema: [
        { key: 'image', label: 'Picture', type: 'image', required: true, help: 'About 1240 × 360 px.' },
        { key: 'mobileImage', label: 'Phone picture', type: 'image', help: 'Optional, about 780 × 400 px.' },
        { key: 'alt', label: 'Picture description', type: 'string', help: 'What the banner says, for screen readers.' },
        { key: 'link', label: 'Link', type: 'string', placeholder: '/shop' },
      ],
      default: [],
    },
    { key: 'autoplay', label: 'Play automatically', type: 'boolean', default: true },
    { key: 'autoplaySeconds', label: 'Seconds per slide', type: 'number', default: 5, dependency: { field: 'autoplay', value: true } },
    ...SECTION_STYLE_FIELDS,
  ],
}
